import { Cart } from '@api/cart/cart.models';
import { PageSection } from '@core/domain/types/page-sections.types';
import { ProductViewPlace, ProductViewPlaceValue } from '@shared/product/models';

export const getRelatedsSectionUseCase = (
    page: PageSection,
    productPageDetailSection: string,
    lastSection: string,
    shopCart: Cart,
    placeName: ProductViewPlace,
): number => {
    const sectionParser: Record<string, number> = {
        DEFAULT: 0,
        WOMEN: 1,
        MEN: 2,
    };

    if (placeName === ProductViewPlaceValue.SEARCH) {
        return sectionParser[lastSection];
    }

    if (page === 'ItxAngularShopcartPage') {
        const hasWomenProducts: boolean = shopCart.items.some(item => item.section === '1');
        const hasMenProducts: boolean = shopCart.items.some(item => item.section === '2');

        if (shopCart.isEmpty || hasWomenProducts && hasMenProducts) {
            return sectionParser.DEFAULT;
        }

        return hasWomenProducts ? sectionParser.WOMEN : sectionParser.MEN;
    }

    // biome-ignore lint/style/useNumberNamespace: <explanation>
    return parseInt(productPageDetailSection) || sectionParser[lastSection];
};
